module.exports = firebase-admin;